import { useEffect, useState } from 'react';
import { useApiService } from '../services/apiService';
import { Button } from './ui/button';

type PromptSettings = { prompt: string; defaultPrompt: string };
export function AiPromptSettings() {
  const api = useApiService();
  const [prompt, setPrompt] = useState('');
  const [loaded, setLoaded] = useState(false);
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState('');
  useEffect(() => {
    let active = true;
    api.get<PromptSettings>('/settings/ai-prompts/field-description').then(result => { if (active) { setPrompt(result.prompt); setLoaded(true); } }).catch(() => { if (active) setMessage('Unable to load AI prompt settings.'); });
    return () => { active = false; };
  }, [api]);
  const save = async (value: string | null) => {
    setBusy(true); setMessage('');
    try { const result = await api.put<PromptSettings>('/settings/ai-prompts/field-description', { prompt: value }); setPrompt(result.prompt); setMessage(value === null ? 'Default prompt restored.' : 'Prompt saved.'); }
    catch { setMessage('Unable to save the prompt. Please try again.'); }
    finally { setBusy(false); }
  };
  return <div className="max-w-3xl space-y-4"><h2 className="text-lg font-semibold">Field description prompt</h2><p className="text-sm text-muted-foreground">These shared instructions guide AI improvements to field descriptions.</p><label className="block space-y-2"><span>Prompt</span><textarea className="min-h-48 w-full rounded border bg-background p-2" value={prompt} maxLength={8000} disabled={!loaded || busy} onChange={e => setPrompt(e.target.value)} /></label><div className="flex gap-2"><Button disabled={!loaded || busy || !prompt.trim()} onClick={() => void save(prompt)}>Save prompt</Button><Button variant="outline" disabled={!loaded || busy} onClick={() => void save(null)}>Reset to default</Button></div>{message && <p role="status">{message}</p>}</div>;
}
